import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, Layout, Typography, Divider } from "antd";
import "./PublicCatering.scss"
import { ArrowLeftOutlined, BackwardOutlined } from "@ant-design/icons";
import TextArea from "antd/lib/input/TextArea";
import OrderButton from "../../components/OrderButton";
import OrderService from "../../services/OrderService";
import moment from "moment"
import { useHistory, useParams } from "react-router-dom";
import Spinner from "../../components/Layout/Spinner";


const { Header, Content } = Layout;
const { Title } = Typography;
export default function PublicCatering(props) {

    const params = useParams();
    const [isSpin, setSpin] = useState(false);
    const [order, setCateringOrder] = useState();
    const [isQuantityNull, setIsQuantityNull] = useState()
    const [tipValue, setTipValue] = useState(100);
    const [notes, setNotes] = useState();

    const tips =[{name: 15,type:"button"},
    {name: 18,type:"button"},
    {name: 20,type:"button"},
    {name: "No Tip",type:"button"},
    {name: "10%",type:"input"},]
    // const history = useHistory();

    const onChange = (e) => {
        setTipValue(e.target.value);
      };
      const onchangeNotes = (e) => {
        setNotes(e.target.value);
      };
      const onClickTip = (tip) => {
        if(tip == "No Tip")
        setTipValue(0);
    else{
        setTipValue((tip / 100) * 10000)
    }
      };
    useEffect(() => {
      getCateringdetails();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
  
   
  
    const getCateringdetails = async (values) => {
    //   const id = props.match.params.cateringId;
      setSpin(true);
      const data = await OrderService.getCateringDetailsEncripted(params.code);
      setCateringOrder(data);
      setNotes(data?.description)
      setIsQuantityNull(data?.catering_request_items?.some(item=>item.quantity == null || !item.quantity))

  
      setSpin(false);
    };

    const addCount =(item,isAdd)=>{

    }
    const updateRequest= async()=>{
        const obj={
            restaurant_id: order?.restaurant_id,
            description: order?.description,
            start_time: order?.start_time,
            time_zone: "Africa/Asmera",
            is_approved: order?.is_approved,
            customer_location_id: order?.customer_location_id,
            guest_count: order?.guest_count,
            catering_request_items: order?.catering_request_items.map(item=>{
                return {
                    menu_item_id : item.menu_item_id,
                    quantity : item.quantity
                }
            }
                 
            )
               
            
        }
        setSpin(true);
      const data = await OrderService.updateCatering(obj,order?.id);
      setSpin(false)
    }
    return (
        <Content className="catering-request-public">
            <Header className="header" >
                <div><ArrowLeftOutlined className="back-arrow" />Back To Menu</div>

            </Header>
            {isSpin?<Spinner/>:
            <Content className="page-content">
                <div className="cat-request-details">
                    <div className="cat-event-section">
                        <div className="cat-type-header">Event Details</div>
                        <div className="event-details-desc">
                            <div className="event-details-item">{moment(order?.event_time).format("MM/DD/yyyy h:mm:ss a")}</div>
                            <div className="event-details-item">{order?.event_type}</div>
                            <div className="event-details-item">{order?.guest_count ? order?.guest_count+" " : "--- "} Guests</div>
                            <div className="event-details-item"></div>
                        </div>
                    </div>
                    <Divider className="m-50"/>

                    <div className="cat-event-section">
                        <div className="cat-type-header">Event Location</div>
                        <div className="event-details-desc">
                            <div className="event-details-item event-address">
                                <div className="w-5 b-20"> {order?.customer_location?.address_field1 }</div>
                                <div> {order?.customer_location?.address_field2 } <br/>
                                {order?.customer_location?.city + ","+order?.customer_location?.country } <br/>
                                Zip: {order?.customer_location?.postal_code }</div>
                            </div>
                            {/* <TextArea className="location-istruction" placeholder="Add Instruction"/> */}
                        </div>
                    </div>
                    <Divider className="m-50"/>

                    <div className="cat-event-section">
                        <div className="cat-type-header">Item Selected</div>
                        <div className="cat-event-menus">
                        {order?.catering_request_items?.map(item=>
                        <div className="event-details-desc event-menu">
                            <div className="event-quantity-div">
                            {!isQuantityNull &&   <div className="event-quantity">{item?.quantity} X </div> }
                            <div className="event-details-item">
                                <div className="w-5 b-20">{item?.menu_item?.name}</div>
                                <div>{item?.menu_item?.description}</div>
                            </div>
                            </div>
                            <div className="event-details-item">
                            <div className="w-5 b-20">${item?.menu_item?.price}</div>
                            {isQuantityNull &&
                            <OrderButton
                      count={1}
                      increment={() => addCount({},true)}
                      decrement={() => addCount({},false)}
                    />
                            }
                            </div>
                            
                        </div>
                        )}
                        </div>
                    </div>
                    <Divider className="m-50"/>

                    <div className="cat-event-section">
                        <div className="cat-type-header">Tip</div>
                        <div className="event-details-desc">
                            <div className="event-details-item" style={{width:"100%"}}>
                                {tips.map(item=>
                                   item.type==="button"? <Button type="text" danger onClick={()=>onClickTip(item.name)}>{item.name}%</Button>:
                                   <Input value={tipValue} className="tip-width" prefix={"$"} onChange={onChange}/>)}
                            </div>
                            
                        </div>
                    </div>
                    <Divider className="m-50"/>

                    <div className="cat-event-section">
                        <div className="cat-type-header">Notes</div>
                        <div className="event-details-desc">
                            <div className="event-details-item" style={{width:"100%"}}>
                                <TextArea placeholder="Enter Notes Here" defaultValue={order?.description}
                                value={notes} onChange={onchangeNotes}/>
                            </div>
                            
                        </div>
                    </div>
                    <Divider className="m-50"/>

                    

                </div>
                <div className="price-layout">
                    <div className="catering-rest">
                        <div className="cat-from">Catering Order From</div>
                        <div className="cat-rest-name">{order?.restaurant?.name}</div>
                    </div>
                    <div>
                        <div className="price-section">
                            <div>SubTotal</div>
                            <div> $115.5 </div>
                        </div>
                        <div className="price-section">
                            <div>Taxes and Fees</div>
                            <div> $115.5 </div>
                        </div>
                        <div className="price-section">
                            <div>Delivery Fee</div>
                            <div> $115.5 </div>
                        </div>
                        <div className="price-section">
                            <div>Tip</div>
                            <div> ${tipValue} </div>
                        </div>
                        <Divider className="price-div"/>
                        <div className="price-section total-price">
                            <div>Total</div>
                            <div> $115.5 </div>
                        </div>
                        <Button onClick={()=>updateRequest()} primary className="request-btn">Request Catering</Button>
                    </div>

                </div>
            </Content>
}
        </Content>
    );
}





